<template>
  <a href="https://activeimage.io/exhibitions/-N7bZ5tZSHNtrFJZLhmF/hans-zimmer-live-collect-visual-memories?utm_source=sendinblue&utm_campaign=Now%20available%20Hans%20Zimmer%20Live%20digital%20collectibles%20exclusively%20on%20Active%20Image&utm_medium=email" target="_blank">
    <v-img
      :src="backgroundImage"
      width="330"
      height="600"
      style="position: relative;"
      class="mx-auto"
    >
      <div
        style="position: absolute; top: 0px; left: 0px;"
        class="ma-5 font-weight-bold"
      >
      </div>
      <div
        style="overflow: hidden; height: 600px; width: 100%;"
      >
      </div>
    </v-img>
  </a>
</template>
<script>
import SendRequestMixin from "../../mixins/SendRequestMixin";

export default {
  name: "TheCollectible",
  mixins: [SendRequestMixin],
  data() {
    return {
      loading: false,
      events: [],
      backgroundImage: ""
    };
  },
  computed: {
    listEvents() {
      return this._.filter(this.events, function(n) {
        return Date.parse(n.date) > Date.now();
      }).reverse();
    }
  },
  methods: {
    changePhoto() {
      const _vm = this;

      setTimeout(() => {
        let images = ["/collectible_infinity.jpg", "/collectible_HZL.jpg", "/collectible_deepnight_1.jpg"];
        this.backgroundImage =
          window.location.origin +
          "/img/collectible" +
          images[Math.floor(Math.random() * 3)];
        _vm.changePhoto();
      }, 7000);
    }
  },
  mounted() {
    this.changePhoto();
  }
};
</script>
